'use client';

import { SectionHeader } from '../shared';

interface StatValue {
  field: string;
  value: number | string | null | undefined;
  label?: string;
}

interface StatsSectionProps {
  stats: StatValue[];
  label?: string | null;
}

function formatStatLabel(field: string): string {
  // Convert snake_case to Title Case
  return field
    .replace(/_/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase());
}

function formatStatValue(value: number | string | null | undefined): string {
  if (value == null) return '-';
  if (typeof value === 'number') {
    // Format currency-like values
    if (value >= 1000) {
      return value.toLocaleString();
    }
    return value.toString();
  }
  return value;
}

const GRID_COLS: Record<number, string> = {
  1: 'grid-cols-1',
  2: 'grid-cols-2',
  3: 'grid-cols-3',
};

export function StatsSection({ stats, label }: StatsSectionProps) {
  const validStats = stats.filter(s => s.value != null);

  if (validStats.length === 0) {
    return null;
  }

  const cols = GRID_COLS[validStats.length] ?? 'grid-cols-2';

  return (
    <div>
      {label && <SectionHeader title={label} />}
      <div className={`grid ${cols} gap-2`}>
        {validStats.map((stat) => (
          <div
            key={stat.field}
            className="p-2 rounded-lg bg-card border border-border text-center"
          >
            <div className="text-sm font-semibold">
              {formatStatValue(stat.value)}
            </div>
            <div className="text-[10px] text-muted-foreground">
              {stat.label || formatStatLabel(stat.field)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
